import * as React from "react";
import { useMachine } from "@xstate/react";
import { useProducts } from "@nju/data-access-portal-product";
import { generatePasswordMachine } from "./generatePassword.machine";
import { GeneratePassword } from "./partials/GeneratePassword";
import { GeneratePasswordError } from "./partials/GeneratePasswordError";
import { GeneratePasswordSuccess } from "./partials/GeneratePasswordSuccess";

export function DashboardGenerateNewRouterPasswordPage() {
  const { ftthProducts } = useProducts();
  const { internet } = ftthProducts;
  const [{ context, matches }, send] = useMachine(generatePasswordMachine, {
    context: {
      productId: internet?.id,
    },
  });

  const generatePassword = React.useCallback(() => {
    send({ type: "GENERATE_PASSWORD" });
  }, [send]);

  if (matches("success") && context.password) {
    return <GeneratePasswordSuccess password={context.password} />;
  }

  if (matches("error")) {
    return <GeneratePasswordError />;
  }

  return (
    <GeneratePassword
      generatePassword={generatePassword}
      isLoading={matches("send")}
    />
  );
}
